/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyStockBill } from 'app/shared/model/pharmacy-stock-bill.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';

export interface IPharmacyPaymentHistory {
  id?: string;
  paymentMethod?: string | null;
  transactionDetails?: string | null;
  paidAmount?: number | null;
  active?: boolean | null;
  cursor?: number;
  timestampentry?: number | null;
  microSec?: number | null;
  lastupdated?: number | null;
  paymentStatus?: keyof typeof PaymentStatus | null;
  forCredit?: boolean | null;
  addedById?: string | null;
  modifiedById?: string | null;
  addedByType?: keyof typeof PharmacyAddedByType | null;
  modifiedByType?: keyof typeof PharmacyAddedByType | null;
  cancelledReason?: string | null;
  pharmacyStockBill?: IPharmacyStockBill | null;
}

export const defaultValue: Readonly<IPharmacyPaymentHistory> = {
  active: false,
  forCredit: false,
};
